import Reveal from "@/components/Reveal";
import { Camera, History, Landmark } from "lucide-react";

const CARDS = [
  {
    icon: Camera,
    title: "Corner Foto Dedicato",
    text: "Un angolo foto allestito per l'occasione: fermati, sorridi e porta a casa il ricordo di questa giornata.",
    testId: "museum-card-foto",
  },
  {
    icon: History,
    title: "Esperienza Immersiva",
    text: "Un percorso che ti porta indietro nel tempo, tra i momenti e le persone che hanno scritto la storia di Tecnosystem.",
    testId: "museum-card-esperienza",
  },
  {
    icon: Landmark,
    title: "Il Museo dei 45 Anni",
    text: "Un museo allestito per ripercorrere questi 45 anni, passo dopo passo, dal 1981 a oggi.",
    testId: "museum-card-museo",
  },
];

const Museo = () => (
  <section id="museo" className="relative overflow-hidden bg-[#101112] py-28 sm:py-36" data-testid="museum-section">
    <div className="absolute -top-40 left-1/2 h-96 w-[42rem] -translate-x-1/2 rounded-full bg-[#E30613]/15 blur-3xl" aria-hidden="true" />
    <div className="relative mx-auto max-w-6xl px-6">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#FF5A64]">Il Museo</p>
        <div className="mt-4 flex items-center gap-1.5" aria-hidden="true">
          <span className="h-[3px] w-12 rounded-full bg-[#009246]" />
          <span className="h-[3px] w-12 rounded-full bg-[#F5F5F3]" />
          <span className="h-[3px] w-12 rounded-full bg-[#E30613]" />
        </div>
        <h2 className="mt-6 font-display text-2xl font-semibold uppercase tracking-[0.06em] text-white sm:text-3xl lg:text-4xl">
          Un viaggio <span className="text-[#E30613]">indietro nel tempo</span>
        </h2>
        <div className="mt-8 max-w-2xl space-y-4 text-lg font-light leading-relaxed text-[#C9CBC9]">
          <p>Questa giornata è dedicata agli espositori e alle promozioni.</p>
          <p>Ma soprattutto è dedicata a festeggiare insieme i nostri 45 anni.</p>
          <p>Per questo abbiamo creato qualcosa di speciale.</p>
        </div>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12}>
            <div className="h-full rounded-2xl border border-white/10 bg-white/[0.04] p-8 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#E30613]/50 hover:bg-white/[0.07]" data-testid={c.testId}>
              <span className="flex h-12 w-12 items-center justify-center rounded-full border border-[#E30613]/40 bg-[#E30613]/15">
                <c.icon size={20} className="text-[#FF5A64]" />
              </span>
              <h3 className="mt-6 font-display text-lg font-semibold uppercase tracking-[0.05em] text-white">{c.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-[#A9ABA9]">{c.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 border-l-2 border-[#E30613] pl-8 sm:pl-10">
          <p className="font-display text-xl font-semibold uppercase leading-relaxed tracking-[0.06em] text-white sm:text-2xl" data-testid="museum-closing">
            Magari ti ci ritroverai anche tu.
          </p>
          <p className="mt-3 font-display text-xl font-semibold uppercase leading-relaxed tracking-[0.06em] text-[#E30613] sm:text-2xl">
            Perché ne hai fatto parte.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Museo;
